import {call, put} from 'redux-saga/effects';

import axios from 'axios';
import * as lexActionType from '../actionsType/lexFavourite.actionType';
import {getBaseUrl} from '../../../core/utility/filter.utility';

function addRemoveFavorite(reqObj) {
    // `${getBaseUrl()}/rest/lex/enrollUesrIntoLEX`
    // http://localhost:3001/enroll
    return axios({
        method: 'post',
        url: `${getBaseUrl()}/rest/cockpit/addRemoveFavouriteContent`,
        data: {
            cId: reqObj.cId,
            cType: reqObj.cType,
            choice: reqObj.choice,
            uuid: reqObj.uuid,
            tenantId: reqObj.tenantId,
            aTy: reqObj.aTy,
            nW: reqObj.nW
        }
    });
}


export function* fetchaddRemoveFavoriteSaga(request) {
    try {
        const response = yield call(addRemoveFavorite, request.payload);
        const content = response.data.status;
        yield put({
            type: lexActionType.LEX_FAVORITE_SUCCESS,
            payload: content
        });
    } catch (error) {
        yield put({
            type: lexActionType.LEX_FAVORITE_ERROR,
            payload: 'There has been some issue with 3DS Learning Space. Please try after sometime.'
        });
    }
}
